import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Tooltip } from '@mui/material';
import { dailyNormCard } from '@/styles/tokens';

// Мітка «мої»: у експерта є власний запис денних норм для клієнта (один запис на всі значення - одна мітка).
export const OwnNormsBadge: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t('clientProfile.dailyNorms.ownHint')}>
      <Box
        component="span"
        sx={{
          px: '6px',
          borderRadius: '4px',
          fontSize: 11,
          lineHeight: '16px',
          fontWeight: 400,
          bgcolor: dailyNormCard.ownBadgeBg,
          color: dailyNormCard.ownBadgeText,
          cursor: 'default',
        }}
      >
        {t('clientProfile.dailyNorms.ownBadge')}
      </Box>
    </Tooltip>
  );
};
